import { render } from "./GMarcasModal.vue?vue&type=template&id=5b3f2966"
import script from "./GMarcasModal.vue?vue&type=script&lang=js"
export * from "./GMarcasModal.vue?vue&type=script&lang=js"

import "./GMarcasModal.vue?vue&type=style&index=0&id=5b3f2966&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__